import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { Category } from '@mui/icons-material';
import CategoryManagementTable from '../../components/admin/categories/CategoryManagementTable';

const CategoryManagement = () => {
    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Paper elevation={4} sx={{
                mb: 4,
                p: 4,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #ff9800, #ffb74d)',
                color: 'white'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Avatar sx={{
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '3px solid rgba(255,255,255,0.3)',
                        width: 80,
                        height: 80
                    }}>
                        <Category sx={{ fontSize: 40 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
                            Category Management
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9 }}>
                            Manage waste classification categories
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                            Create, edit, and organize waste sorting categories
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {/* Category Management Table */}
            <CategoryManagementTable />
        </Box>
    );
};

export default CategoryManagement;
